import {NgModule} from '@angular/core';
import {
	ActivatedRoute,
	ActivatedRouteSnapshot,
	NavigationEnd,
	NavigationError,
	NavigationStart,
	Router,
	RouterModule, RouterStateSnapshot,
	Routes
} from '@angular/router';
import {PageNotFoundComponent} from "./components/common/page-not-found/page-not-found.component";
import {AuthService} from "./services/auth.service";
import {DashboardComponent} from "./components/pages/dashboard/dashboard.component";
import {ProjectsComponent} from "./components/pages/projects/projects.component";
import {ProjectsResolver} from "./resolvers/projects.resolver";

const routes: Routes = [
	{
		path: '',
		redirectTo: 'projects',
		pathMatch: 'full',
	},  {
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthService],
		resolve: {
		}
	}, {
		path: 'projects',
		component: ProjectsComponent,
		canActivate: [AuthService],
		resolve: {
			projects : ProjectsResolver
		}
	},
	{
		path: '**',
		component: PageNotFoundComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		onSameUrlNavigation: 'reload'
	})],
	exports: [RouterModule],
	providers: [

	]
})
export class AppRoutingModule {

	constructor(private router: Router) {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {

			}

			if (event instanceof NavigationEnd) {
				// Hide loading indicator
			}

			if (event instanceof NavigationError) {

			}
		});
	}

}
